webpackJsonp([17,15],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(45);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(315);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _App = __webpack_require__(245);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueResource = __webpack_require__(250);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueRouter = __webpack_require__(212);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _router = __webpack_require__(314);
	
	var _router2 = _interopRequireDefault(_router);
	
	__webpack_require__(234);
	
	var _Global = __webpack_require__(246);
	
	var _Global2 = _interopRequireDefault(_Global);
	
	var _index = __webpack_require__(213);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(348);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(347);
	
	var _index6 = _interopRequireDefault(_index5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(235);
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.http.options.emulateJSON = false;
	_vue2.default.http.options.emulateHTTP = true;
	
	_vue2.default.http.options.crossOrigin = true;
	_vue2.default.http.options.xhr = { withCredentials: true };
	_vue2.default.http.headers.common['auth'] = localStorage.getItem("auth");
	window.Vue = _vue2.default;
	_vue2.default.prototype.GLOBAL = _Global2.default;
	
	
	_vue2.default.use(_index2.default);
	_vue2.default.use(_index4.default);
	_vue2.default.use(_index6.default);
	localStorage.setItem("jump", '');
	_vue2.default.http.interceptors.push(function (request, next) {
	  next(function (res) {
	    if (res.status == 401) {
	      console.log('auth401...');
	      window.location.href = 'index.html#/login#';
	    }
	  });
	});
	
	new _vue2.default({
	  template: '<App/>',
	  router: _router2.default,
	  store: _store2.default,
	  components: { App: _App2.default }
	}).$mount('#app');

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(230)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(323),
	  /* template */
	  __webpack_require__(271),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(228)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(316),
	  /* template */
	  __webpack_require__(265),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	/* customBlocks */
	__webpack_require__(247)
	
	
	module.exports = Component.exports


/***/ }),

/***/ 225:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 227:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 228:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 230:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(225)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(317),
	  /* template */
	  __webpack_require__(259),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	/* customBlocks */
	__webpack_require__(248)
	
	
	module.exports = Component.exports


/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(227)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(324),
	  /* template */
	  __webpack_require__(263),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(231)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(326),
	  /* template */
	  __webpack_require__(272),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(327),
	  /* template */
	  null,
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 247:
/***/ (function(module, exports) {



/***/ }),

/***/ 248:
/***/ (function(module, exports) {



/***/ }),

/***/ 259:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": _vm.transition
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "weui-loading_toast vux-loading",
	    class: !_vm.text ? 'vux-loading-no-text' : ''
	  }, [_c('div', {
	    staticClass: "weui-mask_transparent"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "weui-toast",
	    style: ({
	      position: _vm.position
	    })
	  }, [_c('i', {
	    staticClass: "weui-loading weui-icon_toast"
	  }), _vm._v(" "), (_vm.text) ? _c('p', {
	    staticClass: "weui-toast__content"
	  }, [_vm._v(_vm._s(_vm.text || '加载中')), _vm._t("default")], 2) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-x-dialog",
	    class: {
	      'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": _vm.maskTransition
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "weui-mask",
	    style: (_vm.maskStyle),
	    on: {
	      "click": _vm.hide
	    }
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": _vm.dialogTransition
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    class: _vm.dialogClass,
	    style: (_vm.dialogStyle)
	  }, [_vm._t("default")], 2)])], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-confirm"
	  }, [_c('x-dialog', {
	    attrs: {
	      "dialog-class": _vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',
	      "mask-transition": _vm.maskTransition,
	      "dialog-transition": _vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,
	      "hide-on-blur": _vm.hideOnBlur,
	      "mask-z-index": _vm.maskZIndex
	    },
	    on: {
	      "on-hide": function($event) {
	        _vm.$emit('on-hide')
	      }
	    },
	    model: {
	      value: (_vm.showValue),
	      callback: function($$v) {
	        _vm.showValue = $$v
	      },
	      expression: "showValue"
	    }
	  }, [(!!_vm.title) ? _c('div', {
	    staticClass: "weui-dialog__hd",
	    class: {
	      'with-no-content': !_vm.showContent
	    }
	  }, [_c('strong', {
	    staticClass: "weui-dialog__title"
	  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), (_vm.showContent) ? [(!_vm.showInput) ? _c('div', {
	    staticClass: "weui-dialog__bd"
	  }, [_vm._t("default", [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.content)
	    }
	  })])], 2) : _c('div', {
	    staticClass: "vux-prompt"
	  }, [(((_vm.getInputAttrs()).type) === 'checkbox') ? _c('input', _vm._b({
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.msg),
	      expression: "msg"
	    }],
	    ref: "input",
	    staticClass: "vux-prompt-msgbox",
	    attrs: {
	      "placeholder": _vm.placeholder,
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.msg) ? _vm._i(_vm.msg, null) > -1 : (_vm.msg)
	    },
	    on: {
	      "touchend": _vm.setInputFocus,
	      "change": function($event) {
	        var $$a = _vm.msg,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.msg = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.msg = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.msg = $$c
	        }
	      }
	    }
	  }, 'input', _vm.getInputAttrs(), false)) : (((_vm.getInputAttrs()).type) === 'radio') ? _c('input', _vm._b({
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.msg),
	      expression: "msg"
	    }],
	    ref: "input",
	    staticClass: "vux-prompt-msgbox",
	    attrs: {
	      "placeholder": _vm.placeholder,
	      "type": "radio"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.msg, null)
	    },
	    on: {
	      "touchend": _vm.setInputFocus,
	      "change": function($event) {
	        _vm.msg = null
	      }
	    }
	  }, 'input', _vm.getInputAttrs(), false)) : _c('input', _vm._b({
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.msg),
	      expression: "msg"
	    }],
	    ref: "input",
	    staticClass: "vux-prompt-msgbox",
	    attrs: {
	      "placeholder": _vm.placeholder,
	      "type": (_vm.getInputAttrs()).type
	    },
	    domProps: {
	      "value": (_vm.msg)
	    },
	    on: {
	      "touchend": _vm.setInputFocus,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.msg = $event.target.value
	      }
	    }
	  }, 'input', _vm.getInputAttrs(), false))])] : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "weui-dialog__ft"
	  }, [(_vm.showCancelButton) ? _c('a', {
	    staticClass: "weui-dialog__btn weui-dialog__btn_default",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": _vm._onCancel
	    }
	  }, [_vm._v(_vm._s(_vm.cancelText || '取消'))]) : _vm._e(), _vm._v(" "), (_vm.showConfirmButton) ? _c('a', {
	    staticClass: "weui-dialog__btn",
	    class: ("weui-dialog__btn_" + _vm.confirmType),
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": _vm._onConfirm
	    }
	  }, [_vm._v(_vm._s(_vm.confirmText || '确定'))]) : _vm._e()])], 2)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-toast"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isShowMask && _vm.show),
	      expression: "isShowMask && show"
	    }],
	    staticClass: "weui-mask_transparent"
	  }), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": _vm.currentTransition
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "weui-toast",
	    class: _vm.toastClass,
	    style: ({
	      width: _vm.width
	    })
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.type !== 'text'),
	      expression: "type !== 'text'"
	    }],
	    staticClass: "weui-icon-success-no-circle weui-icon_toast"
	  }), _vm._v(" "), (_vm.text) ? _c('p', {
	    staticClass: "weui-toast__content",
	    style: (_vm.style),
	    domProps: {
	      "innerHTML": _vm._s(_vm.text)
	    }
	  }) : _c('p', {
	    staticClass: "weui-toast__content",
	    style: (_vm.style)
	  }, [_vm._t("default")], 2)])])], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    staticClass: "router",
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('router-view', {
	    staticClass: "r"
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(45);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(212);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var index = function index(resolve) {
	    __webpack_require__.e/* nsure */(11, function () {
	        resolve(__webpack_require__(190));
	    });
	};
	
	var bills = function bills(resolve) {
	    __webpack_require__.e/* nsure */(13, function () {
	        resolve(__webpack_require__(189));
	    });
	};
	var addbill = function addbill(resolve) {
	    __webpack_require__.e/* nsure */(0, function () {
	        resolve(__webpack_require__(187));
	    });
	};
	var w_product = function w_product(resolve) {
	    __webpack_require__.e/* nsure */(14, function () {
	        resolve(__webpack_require__(200));
	    });
	};
	var stock = function stock(resolve) {
	    __webpack_require__.e/* nsure */(10, function () {
	        resolve(__webpack_require__(197));
	    });
	};
	var login = function login(resolve) {
	    __webpack_require__.e/* nsure */(7, function () {
	        resolve(__webpack_require__(191));
	    });
	};
	var recharge = function recharge(resolve) {
	    __webpack_require__.e/* nsure */(1, function () {
	        resolve(__webpack_require__(195));
	    });
	};
	var mlookup = function mlookup(resolve) {
	    __webpack_require__.e/* nsure */(3, function () {
	        resolve(__webpack_require__(192));
	    });
	};
	var recharge_log = function recharge_log(resolve) {
	    __webpack_require__.e/* nsure */(4, function () {
	        resolve(__webpack_require__(196));
	    });
	};
	var member = function member(resolve) {
	    __webpack_require__.e/* nsure */(12, function () {
	        resolve(__webpack_require__(193));
	    });
	};
	var addstore = function addstore(resolve) {
	    __webpack_require__.e/* nsure */(6, function () {
	        resolve(__webpack_require__(188));
	    });
	};
	var ts = function ts(resolve) {
	    __webpack_require__.e/* nsure */(9, function () {
	        resolve(__webpack_require__(199));
	    });
	};
	var wait_list = function wait_list(resolve) {
	    __webpack_require__.e/* nsure */(8, function () {
	        resolve(__webpack_require__(201));
	    });
	};
	var order_report = function order_report(resolve) {
	    __webpack_require__.e/* nsure */(5, function () {
	        resolve(__webpack_require__(194));
	    });
	};
	var stock_report = function stock_report(resolve) {
	    __webpack_require__.e/* nsure */(2, function () {
	        resolve(__webpack_require__(198));
	    });
	};
	var routes = [{
	    path: '/login',
	    name: 'login',
	    component: login
	}, {
	    path: '/index',
	    name: 'index',
	    component: index
	}, {
	    path: '/',
	    name: 'index',
	    component: index
	}, {
	    path: '/bills',
	    name: 'bills',
	    component: bills
	}, {
	    path: '/addbill',
	    name: 'addbill',
	    component: addbill
	}, {
	    path: '/w_product',
	    name: 'w_product',
	    component: w_product
	}, {
	    path: '/stock',
	    name: 'stock',
	    component: stock
	}, {
	    path: '/recharge',
	    name: 'recharge',
	    component: recharge
	}, {
	    path: '/mlookup',
	    name: 'mlookup',
	    component: mlookup
	}, {
	    path: '/recharge_log',
	    name: 'recharge_log',
	    component: recharge_log
	}, {
	    path: '/member',
	    name: 'member',
	    component: member
	}, {
	    path: '/addstore',
	    name: 'addstore',
	    component: addstore
	}, {
	    path: '/ts',
	    name: 'ts',
	    component: ts
	}, {
	    path: '/wait_list',
	    name: 'wait_list',
	    component: wait_list
	}, {
	    path: '/order_report',
	    name: 'order_report',
	    component: order_report
	}, {
	    path: '/stock_report',
	    name: 'stock_report',
	    component: stock_report
	}];
	
	exports.default = new _vueRouter2.default({
	    routes: routes
	});

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _defineProperty2 = __webpack_require__(48);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getters;
	
	var _vue = __webpack_require__(45);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(278);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var store = new _vuex2.default.Store({
		state: {
			isLogin: false,
	
			userInfo: {
				'loginname': '',
				'avatar': '',
				'id': '',
				'accesstoken': ''
			},
	
			tipContent: '',
	
			tipShow: false,
	
			message_count: 0,
	
			replies: [],
			isNews: false
		},
		actions: {
			isLogin: function isLogin(_ref) {
				var commit = _ref.commit;
	
				commit('ISLOGIN');
			},
			isNews: function isNews(_ref2) {
				var commit = _ref2.commit;
	
				commit('ISNEWS');
			},
			signOut: function signOut(_ref3) {
				var commit = _ref3.commit;
	
				commit('SIGNOUT');
			},
			setUserInfo: function setUserInfo(_ref4, userInfo) {
				var commit = _ref4.commit;
	
				commit('SETUSERINFO', userInfo);
			},
			setTipContent: function setTipContent(_ref5, content) {
				var commit = _ref5.commit;
	
				commit('SETTIPCONTENT', content);
			},
			setTipShow: function setTipShow(_ref6, status) {
				var commit = _ref6.commit;
	
				commit('SETTIPSHOW', status);
			},
			setNotMessageCount: function setNotMessageCount(_ref7, count) {
				var commit = _ref7.commit;
	
				commit('SETNOTMESSAGECOUNT', count);
			},
			setReplies: function setReplies(_ref8, replies) {
				var commit = _ref8.commit;
	
				commit('SETREPLIES', replies);
			}
		},
		mutations: {
			ISLOGIN: function ISLOGIN(state) {
				state.isLogin = true;
			},
			ISNEWS: function ISNEWS(state) {
				state.isNews = true;
			},
			SIGNOUT: function SIGNOUT(state) {
				state.isLogin = false;
			},
			SETUSERINFO: function SETUSERINFO(state, userInfo) {
				state.userInfo.loginname = userInfo.name;
				state.userInfo.avatar = userInfo.avatar;
				state.userInfo.id = userInfo.id;
				state.userInfo.accesstoken = userInfo.accesstoken;
			},
			SETTIPCONTENT: function SETTIPCONTENT(state, content) {
				state.tipContent = content;
			},
			SETTIPSHOW: function SETTIPSHOW(state, status) {
				state.tipShow = status;
			},
			SETNOTMESSAGECOUNT: function SETNOTMESSAGECOUNT(state, count) {
				state.message_count = count;
			},
			SETREPLIES: function SETREPLIES(state, replies) {
				state.replies = replies;
			}
		},
		getters: (_getters = {
			getLoginState: function getLoginState(state) {
				return state.isLogin;
			}
		}, (0, _defineProperty3.default)(_getters, 'getLoginState', function getLoginState(state) {
			return state.isNews;
		}), (0, _defineProperty3.default)(_getters, 'getUserInfo', function getUserInfo(state) {
			return state.userInfo;
		}), (0, _defineProperty3.default)(_getters, 'getUserInfoAccesstoken', function getUserInfoAccesstoken(state, getters) {
			return getters.getUserInfo.accesstoken;
		}), (0, _defineProperty3.default)(_getters, 'getTipShow', function getTipShow(state) {
			return state.tipShow;
		}), (0, _defineProperty3.default)(_getters, 'getTipContent', function getTipContent(state) {
			return state.tipContent;
		}), (0, _defineProperty3.default)(_getters, 'getNotMessageCount', function getNotMessageCount(state) {
			return state.message_count;
		}), (0, _defineProperty3.default)(_getters, 'getReplies', function getReplies(state) {
			return state.replies;
		}), _getters)
	});
	
	exports.default = store;

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _xDialog = __webpack_require__(243);
	
	var _xDialog2 = _interopRequireDefault(_xDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'confirm',
	  components: {
	    XDialog: _xDialog2.default
	  },
	  props: {
	    value: {
	      type: Boolean,
	      default: false
	    },
	    showInput: {
	      type: Boolean,
	      default: false
	    },
	    placeholder: {
	      type: String,
	      default: ''
	    },
	    theme: {
	      type: String,
	      default: 'ios'
	    },
	    hideOnBlur: {
	      type: Boolean,
	      default: false
	    },
	    title: String,
	    confirmText: String,
	    cancelText: String,
	    maskTransition: {
	      type: String,
	      default: 'vux-fade'
	    },
	    maskZIndex: [Number, String],
	    dialogTransition: {
	      type: String,
	      default: 'vux-dialog'
	    },
	    content: String,
	    closeOnConfirm: {
	      type: Boolean,
	      default: true
	    },
	    inputAttrs: Object,
	    showContent: {
	      type: Boolean,
	      default: true
	    },
	    confirmType: {
	      type: String,
	      default: 'primary'
	    },
	    showCancelButton: {
	      type: Boolean,
	      default: true
	    },
	    showConfirmButton: {
	      type: Boolean,
	      default: true
	    }
	  },
	  created: function created() {
	    this.showValue = this.show;
	    if (this.value) {
	      this.showValue = this.value;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.showValue = val;
	    },
	    showValue: function showValue(val) {
	      var _this = this;
	
	      this.$emit('input', val);
	      if (val) {
	        if (this.showInput) {
	          this.msg = '';
	          setTimeout(function () {
	            if (_this.$refs.input) {
	              _this.setInputFocus();
	            }
	          }, 300);
	        }
	        this.$emit('on-show');
	      }
	    }
	  },
	  data: function data() {
	    return {
	      msg: '',
	      showValue: false
	    };
	  },
	
	  methods: {
	    getInputAttrs: function getInputAttrs() {
	      return this.inputAttrs || {
	        type: 'text'
	      };
	    },
	    setInputValue: function setInputValue(val) {
	      this.msg = val;
	    },
	    setInputFocus: function setInputFocus(evt) {
	      if (evt) {
	        evt.preventDefault();
	      }
	      this.$refs.input.focus();
	    },
	    _onConfirm: function _onConfirm() {
	      if (!this.showValue) {
	        return;
	      }
	      if (this.closeOnConfirm) {
	        this.showValue = false;
	      }
	      this.$emit('on-confirm', this.msg);
	    },
	    _onCancel: function _onCancel() {
	      if (!this.showValue) {
	        return;
	      }
	      this.showValue = false;
	      this.$emit('on-cancel');
	    }
	  }
	};

/***/ }),

/***/ 317:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'loading',
	  model: {
	    prop: 'show',
	    event: 'change'
	  },
	  props: {
	    show: Boolean,
	    text: String,
	    position: String,
	    transition: {
	      type: String,
	      default: 'vux-mask'
	    }
	  },
	  watch: {
	    show: function show(val) {
	      this.$emit('update:show', val);
	    }
	  }
	};

/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _safariFix = __webpack_require__(346);
	
	var _safariFix2 = _interopRequireDefault(_safariFix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'toast',
	  mixins: [_safariFix2.default],
	  props: {
	    value: Boolean,
	    time: {
	      type: Number,
	      default: 2000
	    },
	    type: {
	      type: String,
	      default: 'success'
	    },
	    transition: String,
	    width: {
	      type: String,
	      default: '7.6em'
	    },
	    isShowMask: {
	      type: Boolean,
	      default: false
	    },
	    text: String,
	    position: String
	  },
	  data: function data() {
	    return {
	      show: false
	    };
	  },
	  created: function created() {
	    if (this.value) {
	      this.show = true;
	    }
	  },
	
	  computed: {
	    currentTransition: function currentTransition() {
	      if (this.transition) {
	        return this.transition;
	      }
	      if (this.position === 'top') {
	        return 'vux-slide-from-top';
	      }
	      if (this.position === 'bottom') {
	        return 'vux-slide-from-bottom';
	      }
	      return 'vux-fade';
	    },
	    toastClass: function toastClass() {
	      return {
	        'weui-toast_forbidden': this.type === 'warn',
	        'weui-toast_cancel': this.type === 'cancel',
	        'weui-toast_success': this.type === 'success',
	        'weui-toast_text': this.type === 'text',
	        'vux-toast-top': this.position === 'top',
	        'vux-toast-bottom': this.position === 'bottom',
	        'vux-toast-middle': this.position === 'middle'
	      };
	    },
	    style: function style() {
	      if (this.type === 'text' && this.width === 'auto') {
	        return { padding: '10px' };
	      }
	    }
	  },
	  watch: {
	    show: function show(val) {
	      var _this = this;
	
	      if (val) {
	        this.$emit('input', true);
	        this.$emit('on-show');
	        this.fixSafariOverflowScrolling('auto');
	
	        clearTimeout(this.timeout);
	        this.timeout = setTimeout(function () {
	          _this.show = false;
	          _this.$emit('input', false);
	          _this.$emit('on-hide');
	          _this.fixSafariOverflowScrolling('touch');
	        }, this.time);
	      }
	    },
	    value: function value(val) {
	      this.show = val;
	    }
	  }
	};

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _preventBodyScroll = __webpack_require__(345);
	
	var _preventBodyScroll2 = _interopRequireDefault(_preventBodyScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_preventBodyScroll2.default],
	  name: 'x-dialog',
	  model: {
	    prop: 'show',
	    event: 'change'
	  },
	  props: {
	    show: {
	      type: Boolean,
	      default: false
	    },
	    maskTransition: {
	      type: String,
	      default: 'vux-mask'
	    },
	    maskZIndex: [String, Number],
	    dialogTransition: {
	      type: String,
	      default: 'vux-dialog'
	    },
	    dialogClass: {
	      type: String,
	      default: 'weui-dialog'
	    },
	    hideOnBlur: Boolean,
	    dialogStyle: Object,
	    scroll: {
	      type: Boolean,
	      default: true,
	      validator: function validator(val) {
	        if (false) {
	          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
	        }
	        return true;
	      }
	    }
	  },
	  computed: {
	    maskStyle: function maskStyle() {
	      if (typeof this.maskZIndex !== 'undefined') {
	        return {
	          zIndex: this.maskZIndex
	        };
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (typeof window !== 'undefined') {
	      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
	        this.layout = 'VIEW_BOX';
	      }
	    }
	  },
	
	  watch: {
	    show: function show(val) {
	      this.$emit('update:show', val);
	      this.$emit(val ? 'on-show' : 'on-hide');
	      if (val) {
	        this.addModalClassName();
	      } else {
	        this.removeModalClassName();
	      }
	    }
	  },
	  methods: {
	    shouldPreventScroll: function shouldPreventScroll() {
	      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
	      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
	      if (iOS && hasInput) {
	        return true;
	      }
	    },
	    hide: function hide() {
	      if (this.hideOnBlur) {
	        this.$emit('update:show', false);
	        this.$emit('change', false);
	        this.$emit('on-click-mask');
	      }
	    }
	  },
	  data: function data() {
	    return {
	      layout: ''
	    };
	  }
	};

/***/ }),

/***/ 326:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	exports.default = {};

/***/ }),

/***/ 327:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var isNews = false;
	var loadProduct = false;
	exports.default = {
	  isNews: isNews,
	  loadProduct: loadProduct
	};

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.08ff4ed1c379662d4f65.js